<div class="activation bg-grey d-flex">
  <div class="container mt-auto mb-auto">
    <section>
      <form class="activationform" id="activationForm" name="activationForm">
        <div class="activationPage ps-sm-5 pe-sm-5">
          <div class="container">
            <div class="row mb-2">
              <div
                class="col-md-4 p-1 pre-url text-center dg-urls justify-content-center position-relative align-items-center m-auto"
              >
                <app-dg-environment-details> </app-dg-environment-details>
              </div>
            </div>
            <div class="row shadow">
              <div
                class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 p-3 logo"
              >
                <meta
                  name="viewport"
                  content="width=device-width,height=device-height,initial-scale=1.0"
                />
                <div class="flexbox-centering">
                  <div class="row">
                    <div class="col-md-12 mt-3">
                      <h2 class="text-white digigov-title">
                        TCS DigiGOV™ Framework
                      </h2>
                    </div>
                    <div
                      class="col-md-12 mt-4 digigov-desc-paragraph-container"
                    >
                      <p class="text-center digigov-desc-paragraph">
                        A proven accelerator that adheres to the organization’s
                        vision and digital strategy to ensure rapid digital
                        transformation. Sitting at the core of the
                        organization’s digital ecosystem, our framework
                        eliminates dependency on multiple systems working in
                        silos and creates a 360-degree, scalable and flexible
                        integrated enterprise platform for the organization.
                      </p>
                    </div>
                    <div class="col-md-12 mt-5 digigov-features-container">
                      <div class="row digigov-features">
                        <div
                          class="text-white col-md-4 d-flex flex-column align-items-center"
                        >
                          <mat-icon>code</mat-icon>
                          <span class="mt-1">Technological Expertise</span>
                        </div>
                        <div
                          class="text-white col-md-4 d-flex flex-column align-items-center"
                        >
                          <mat-icon>language</mat-icon>
                          <span class="mt-1">Global Presence</span>
                        </div>
                        <div
                          class="text-white col-md-4 d-flex flex-column align-items-center"
                        >
                          <mat-icon>map</mat-icon>
                          <span class="mt-1">Customer-Driven Roadmap</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 p-4 bg-white activationForm"
              >
                <div class="pre-activation-outlet mx-4 h-100">
                  <div class="forgot-password h-100">
                    <h2>Account Activation</h2>
                    <p class="username"></p>
                    <div class="forgot-password-outlet">
                      <div class="choose-auth-method h-100 d-flex flex-column">
                        <ng-container *ngIf="isProcess">
                          <p>Processing...</p>
                        </ng-container>
                        <ng-container *ngIf="!isProcess">
                          <ng-container *ngIf="isActivate">
                            <p>{{ message + "." }}</p>
                            <p *ngIf="isSuccess">You can login now.</p>

                            <div *ngIf="isSuccess" class="mt-auto text-center">
                              <button
                                color="primary"
                                mat-raised-button
                                (click)="onLogin()"
                              >
                                Proceed To Login Page
                              </button>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="!isActivate">
                            <p>Your account activation is failed.</p>
                            <p>Please try again.</p>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="footer">
                <dg-footer> </dg-footer>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</div>

<!-- <div class="footer position-fixed w-100">
    <dg-footer></dg-footer>
  </div> -->
